import React, { useEffect, useState } from "react";
import axios from "axios";
import { api_path } from "../../shared.js";

export default function StageSummary({
  onStageClick,
  userId,
  salesId,
  datefrom,
  dateto,
  salesTeam,
  salesRole,
}) {
  const [summary, setSummary] = useState([]);
  const [selectedStage, setSelectedStage] = useState(null);
  const url = `${api_path}/customer/get-activitySummary_2.php?userId=${userId}&salesId=${salesId}&datefrom=${datefrom}&dateto=${dateto}&salesTeam=${salesTeam}&salesRole=${salesRole}`;

  useEffect(() => {
    axios.get(url).then((res) => {
      setSummary(res.data);
    });
  }, [userId,salesId, datefrom, dateto]);

  const handleClick = (stage) => {
    const newStage =
      selectedStage && selectedStage === stage ? null : stage?.trim() || null;
    setSelectedStage(newStage);
    if (typeof onStageClick === "function") {
      onStageClick(newStage);
    }
  };

  // 🎨 สีแต่ละ Stage
  const stageColors = {
    Lead: "#fff", // เขียวอ่อน
    "In Contact": "#fff", // เหลืองอ่อน
    "Quotation Sent": "#fff", // ม่วงอ่อน
    "Closed - Won": "#fff", // ฟ้าอ่อน
    "Closed - Lost": "#fff", // แดงอ่อน
    "Follow-up": "#fff", // ม่วงอ่อน
  };

  const borderColors = {
    Telesales: "#17a2b8", // เขียว
    "Sales Visit": "#40c057", // เหลือง
    Quotation: "#ff9800", // ฟ้า
    "Closed - Won": "#198754", // ฟ้า
    "Closed - Lost": "#c92a2a", // แดง
    "Follow-up": "#9c27b0", // ม่วง
  };
  const fontColors = {
    Telesales: "#17a2b8", // เขียว
    "Sales Visit": "#40c057", // เหลือง
    Quotation: "#ff9800", // ฟ้า
    "Closed - Won": "#198754", // ฟ้า
    "Closed - Lost": "#c92a2a", // แดง
    "Follow-up": "#9c27b0", // ม่วง
  };
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 10,
        marginBottom: 20,
        justifyContent: "center",
        width: "100%",
      }}
    >
      {Array.isArray(summary) && summary.length > 0 ? (
        summary.map((item) => {
          const bgColor = "#fff";
          const textColor =
            selectedStage === item.ACTIVITY_NAME
              ? fontColors[item.ACTIVITY_NAME]
              : "#2b2b2bff";

          return (
            <div
              key={item.ACTIVITY_ID}
              onClick={() => handleClick(item.ACTIVITY_ID)}
              style={{
                flex: "1 1 120px",
                border:
                  selectedStage === item.ACTIVITY_NAME
                    ? `2px solid ${
                        borderColors[item.ACTIVITY_NAME] || "#0078d4"
                      }`
                    : `1px solid ${borderColors[item.ACTIVITY_NAME] || "#ccc"}`,
                borderRadius: 12,
                padding: 16,
                textAlign: "center",
                cursor: "pointer",
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                backgroundColor: bgColor,
                color: textColor,
                transition: "0.2s",
              }}
            >
              <div style={{ fontWeight: "bold", fontSize: 18 }}>
                {item.TOTAL}
              </div>
              <div>{item.ACTIVITY_NAME}</div>
            </div>
          );
        })
      ) : (
        <div style={{ color: "#888" }}>ไม่มีข้อมูล</div>
      )}
    </div>
  );
}
